import React from "react";
import styled from "styled-components";

import ExternalLink from "components/ExternalLink";
import CloseIcon from "components/svg/icon-cancel-circle-stroke.svg";

const COOKIE_NAME = "_hide_gdpr_banner";

const CookieConsent = styled.div`
  align-items: center;
  background-color: #fff;
  border-bottom: 1px solid #444;
  left: 0;
  padding: 7px;
  position: fixed !important;
  right: 0;
  top: 0;
  z-index: 100 !important;
`;

const ConsentWrapper = styled.div`
  display: flex;
  margin: 0 auto;
  max-width: 860px;
`;

const ConsentContent = styled.span`
  color: #666;
  display: inline-block;
  flex: 0 1 830px;
  font-size: 14px;
  line-height: 20px;
  margin-right: 10px;

  a {
    color: #f99d1c;
    &:hover {
      color: #fab024;
    }
  }
`;

const CloseButton = styled(CloseIcon)`
  align-self: center;
  cursor: pointer;
  height: 20px;
  width: 20px;
`;

export class CookieBanner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hidden: this.read() === "1",
    };
  }

  read() {
    let nameEQ = `${COOKIE_NAME}=`;
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0)
        return decodeURIComponent(c.substring(nameEQ.length, c.length)) || null;
    }
    return null;
  }

  hideBanner = () => {
    // Remember banner closing for 2 weeks (same as "Remember Me" option)
    const expires = new Date(
      Date.now() + 1000 * 60 * 60 * 24 * 14 /* two weeks */
    ).toUTCString();
    document.cookie = `${COOKIE_NAME}=1; expires=${expires}; path=/`;
    this.setState({ hidden: true });
  };

  render() {
    if (this.state.hidden) return null;
    return (
      <CookieConsent>
        <ConsentWrapper>
          <ConsentContent>
            The SolarWinds AppOptics website uses cookies to make your online
            experience easier and better. By using our website, you consent to
            our use of cookies. For more information on cookies, see our{" "}
            <ExternalLink href="https://www.appoptics.com/privacy">
              Cookie Policy
            </ExternalLink>.
          </ConsentContent>
          <CloseButton onClick={this.hideBanner} />
        </ConsentWrapper>
      </CookieConsent>
    );
  }
}

export default CookieBanner;
